export const EN_STRING_OVERRIDES = {
  WALLET: 'Benefits',
};
